<template>
  <div>
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top: 20px;">
        <el-col>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY" type="daterange" align="right" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button id="search" type="primary" size="medium" @click="handleSearch()">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportAllOrder">导出订单</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" show-summary style="margin-top: 20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="来往单位" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="总金额" prop="TOTAL_SUPPLIER_FEE"></el-table-column>
          <el-table-column label="退货金额" prop="TOTAL_RETURN_FEE"></el-table-column>
          <el-table-column label="实际金额" prop="realFee"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="100"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      projects: [],
      totalCount: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getList();
    this.queryPro();
  },
  methods: {
    // 导出
    exportAllOrder() {
      const data = {
        SERVICE_ID: '10009',
        OTYPE: 35,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.$route.params.id,
        MONTH: this.$route.params.month,
      };
      if (this.searchForm.DAY) {
        data.START_DAY = this.searchForm.DAY[0];
        data.END_DAY = this.searchForm.DAY[1];
      }
      if (this.searchForm.PROJECT_ID) {
        data.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      http.post(data).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // ----拉取项目点
    queryPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getList() {
      const data = {
        SERVICE_ID: '10009',
        OTYPE: 34,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.$route.params.id,
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        MONTH: this.$route.params.month,
      };
      if (this.searchForm.DAY) {
        data.START_DAY = this.searchForm.DAY[0];
        data.END_DAY = this.searchForm.DAY[1];
      }
      if (this.searchForm.PROJECT_ID) {
        data.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      http.post(data).then((result) => {
        if (result.length !== 0) {
          this.totalCount = result[0].TOTAL;
          this.tableData = result[0].list;
          this.tableData.forEach((item, index) => {
            item.realFee = (Math.round((Number(item.TOTAL_SUPPLIER_FEE) - Number(item.TOTAL_RETURN_FEE)) * 100) / 100).toFixed(2);
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/customerDetail.vue